<template lang="html">
  <div class="order-form text-center">
    <b-form @submit.prevent="sendRequest">
      <div class="my-3">
        <h1>Invio richiesta</h1>
        <!-- {{product}} -->

        <CoolLightBox
            :items="gallery_images"
            :index="gallery_index"
            slideshow-color-bar="#71b738"
            @close="gallery_index=null"
        ></CoolLightBox>

        <b-carousel
            id="carousel-1"
            v-model="form.slide"
            :interval="0"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
        >
          <b-carousel-slide v-for="(image , image_i) in product.images" :key="image_i"
                            :img-src="$url(image.thumb.lg)"
          ></b-carousel-slide>
        </b-carousel>


        <!-- <img v-if="product.images.length" :src="$url(product.images[0].thumb.md)" class="immagine-ordine"/> -->
        <h4 v-if="!product.is_varie">{{ product.product_type.code }} / {{ product.name }}</h4>
        <h4 v-else>Varie / {{ product.name }}</h4>
      </div>

      <div class="my-2" v-if="gallery_images.length">
        <b-button @click="gallery_index = 0" variant="primary" size="lg" type="button" :disabled="is_saving">Zoom Foto
          <i class="fas fa-search"></i>
        </b-button>
      </div>

      <hr>

      <div v-if="!$store.user" class="mx-auto my-5">
        <!-- Prima di inviare richieste devi <b>registrarti</b> o effettuare il <b>login</b>.
        <div class="mt-4">
          <b-button @click="$store.show_signup = true" variant="primary">Registrazione</b-button>
          <b-button @click="$store.show_login = true" variant="outline-primary" class="ml-2">Login</b-button>
        </div> -->
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-form-group label="Nome Azienda *">
              <b-form-input v-model="form.company" required/>
            </b-form-group>
          </div>
          <div  class="col-lg-6 col-md-6 col-sm-12">
            <b-form-group label="Indirizzo Email: *">
              <b-form-input v-model="form.email" type="email" required/>
            </b-form-group>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-form-group label="P.IVA *">
              <b-form-input v-model="form.vat_number" required/>
            </b-form-group>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-form-group label="Telefono *">
              <b-form-input v-model="form.phone_number" required/>
            </b-form-group>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-form-group label="Indirizzo *">
              <b-form-input v-model="form.addr_street" required/>
            </b-form-group>
          </div>
          <div class="mx-auto my-5">
            <h4>Di quanti pezzi hai bisogno?</h4>
            <b-input :disabled="is_saving" number v-model="form.quantity" autofocus class="text-center my-2 mx-auto" autocomplete="off" style="width: 8rem" size="lg"/>
          </div>
          <div class="mx-auto my-3">
            <b-button @click="$emit('close')" variant="danger" size="lg" type="button" :disabled="is_saving">Annulla</b-button>
            <b-button class="ml-3" variant="primary" size="lg" type="submit" :disabled="is_saving">Invia richiesta</b-button>
          </div>
        </div>
      </div>
      <div v-else class="mx-auto">
        <div class="my-5">
          <h4>Di quanti pezzi hai bisogno?</h4>
          <b-input :disabled="is_saving" number v-model="form.quantity" autofocus class="text-center my-2 mx-auto" autocomplete="off" style="width: 8rem" size="lg"/>
        </div>
        <div class="my-5">
          <b-button @click="$emit('close')" variant="danger" size="lg" type="button" :disabled="is_saving">Annulla</b-button>
          <b-button class="ml-3" variant="primary" size="lg" type="submit" :disabled="is_saving">Invia richiesta</b-button>
        </div>
      </div>


    </b-form>
  </div>
</template>

<script>
export default {
  props: ['product', 'quantity'],
  data() {
    return {
      is_saving: false,
      gallery_images: [],
      gallery_index: null,
      form: {
        company: null,
        email: null,
        addr_street: null,
        phone_number: null,
        vat_number: null,
        product_id: this.product.id,
        quantity: this.quantity,
        slide: 0,
        sliding: null
      }
    }
  },
  methods: {
    sendRequest() {
      this.is_saving = true
      if(this.form.email){
        //richiesta da parte di utente non loggato
        this.$http.post('orders-notlogin', this.form).then((res) => {
          alert('La tua richiesta è stata inviata con successo')
          console.log(res)
          this.$emit('close')
        }).finally(() => {
          this.is_saving = false
        })
      }else{
        //richiesta da parte di utente loggato
        this.$http.post('orders', this.form).then(() => {
          alert('La tua richiesta è stata inviata con successo, puoi seguirne lo stato nella tua area utente')
          this.$emit('close')
        }).finally(() => {
          this.is_saving = false
        })
      }
    },
    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    setGallery() {
      const gallery_caption = (!this.product.is_varie ? this.product.product_type.code : 'Varie') + ' / ' + this.product.name
      this.gallery_images = this.product.images.map(item => ({
        // title: this.product.user.company,
        description: gallery_caption,
        src: this.$url(item.original)
      }))
    }
  },
  created() {
    this.setGallery()
  }
}
</script>

<style lang="scss">
.immagine-ordine {
  width: 100%;
  height: auto;
}

.carousel-control-prev, .carousel-control-next {
  background-color: #ccccccf5;
  opacity: 0.5;
}
</style>
